import { Injectable } from '@angular/core';
import {ApiService} from "../../api/api.service";

@Injectable({
  providedIn: 'root'
})
export class FinancialsService {

  protected endpoint?: string
  protected customerDetails?: any

  constructor(private apiService: ApiService) {
    this.endpoint = 'financials'
  }

  getFinancialListing() {
    return this.apiService.get('customer/financials', {}, true)
  }

  getProviderFinancialListing(params: {
    page: number;
    pageSize: number;
    sortModel?: any;
    filterModel?: any;
  }) {
    return this.apiService.get('provider/financials/datatable', params, true);
  }


}
